/** @jsx jsx */
import { jsx } from '@emotion/react'
import { ConsentLevel, useConsentGiven } from '@news-mono/web-common'
import React from 'react'
import { ConsentFallback } from '../../../tracking/ConsentFallback/ConsentFallback'
import { metrics, ThemeMargins } from '../../../__styling/settings/metrics'
import { calcRem } from '../../../__styling/style-functions/calc-rem'

export interface OmnyProps {
    link: string
    width?: number
    verticalSpacing?: keyof ThemeMargins
    height?: number
}

const embedLink = '/embed'

const processEmbedLink = (link: string) => {
    if (link.indexOf(embedLink) === -1) {
        return `${link}${embedLink}`
    }
    return link
}

export const isOmny = (link: string) => {
    return link.indexOf('omny.fm') >= 0
}

function isPlaylistEmbed(link: string) {
    return link.indexOf('playlists') !== -1
}

export function omnyHeightValue(props: OmnyProps): string {
    if (isPlaylistEmbed(props.link)) {
        return '500px'
    }

    if (!isPlaylistEmbed(props.link) && props.height) {
        return `${props.height}px`
    }

    return '180px'
}

export const Omny: React.FC<OmnyProps> = (props) => {
    const consentGiven = useConsentGiven({
        consentRequiredLevel: ConsentLevel.Analytics | ConsentLevel.Advertising,
    })

    if (!consentGiven) {
        return <ConsentFallback />
    }

    return (
        <iframe
            css={{
                marginBottom:
                    props.verticalSpacing &&
                    calcRem(metrics.thewest.margins[props.verticalSpacing]),
            }}
            width={props.width ? `${props.width}px` : '100%'}
            height={omnyHeightValue(props)}
            frameBorder={0}
            src={processEmbedLink(props.link)}
            sandbox={'allow-same-origin allow-popups allow-scripts'}
        />
    )
}
